import React, { Component } from 'react';
import { translate } from 'react-i18next';

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagoAutomatico: true,
      pagoManual: false,
      messageText: '',
      ingresoPago: '',
      comisionPago: '',
      totalPago: ''
    }
  }

  componentWillMount = () => {
    const round2 = (n) => Math.round((+n + Number.EPSILON) * 100) / 100;
    const MAX_CHARGE = 190000

    //let totalPesos = (this.props.invoice.balance_mxn && this.props.invoice.balance_mxn <= 190000) ? this.props.invoice.balance_mxn : 190000.00;
    let totalPesos = 0;
    this.props.get_data_invoices.map((invoice, index) => {
      if (invoice.status === 1) {
        totalPesos += Number(invoice.balance_mxn)
      }
    })

    /*let comision = Number((((3.01) / 100) * totalPesos) + (2.5)).toFixed(2)
    let ivaComision = Number(comision * .16).toFixed(2)
    let comisionTotal = Number(parseFloat(comision) + parseFloat(ivaComision)).toFixed(2)*/

    //Se calcula comision de conekta para generer el cargo. Conekta utiliza el 3.4% + 3 + IVA de interes. Internamete se agrega 0.01 para tener ganacia cambiaria)
    const conekta_porcentaje_comision = (+process.env.REACT_APP_CONEKTA_PERCENTAGE_FEE / 100);
    const conekta_añadido_comision = +process.env.REACT_APP_CONEKTA_FIXED_FEE;
    const conekta_iva = +process.env.REACT_APP_CONEKTA_IVA;
    const ganancia_cambiaria = 0.01;
    let comisionTotal = (((totalPesos * conekta_porcentaje_comision) + conekta_añadido_comision) * (1 + conekta_iva) + ganancia_cambiaria) / (1 - (conekta_porcentaje_comision * (1 + conekta_iva))).toFixed(2);
    let totalCargoTarjeta = (parseFloat(totalPesos + comisionTotal).toFixed(2))

    if (totalCargoTarjeta > MAX_CHARGE) {
      // Total = k * neto + c (lineal)
      // A = p*(1+iva), B = f*(1+iva) + g, denom = 1 - A
      const A = conekta_porcentaje_comision * (1 + conekta_iva);
      const B = conekta_añadido_comision * (1 + conekta_iva) + ganancia_cambiaria;
      const denom = round2(1 - A);
      const k = 1 + A / denom;
      const c = B / denom;
      totalPesos = Math.max(0, (MAX_CHARGE - c) / k);
      comisionTotal = (((totalPesos * conekta_porcentaje_comision) + conekta_añadido_comision) * (1 + conekta_iva) + ganancia_cambiaria) / (1 - (conekta_porcentaje_comision * (1 + conekta_iva))).toFixed(2);
      totalCargoTarjeta = (parseFloat(totalPesos + comisionTotal).toFixed(2))
    }

    this.setState({
      ingresoPago: totalPesos,
      comisionPago: comisionTotal,
      totalPago: totalCargoTarjeta
    })
    if (this.props.invoice.balance_mxn && this.props.invoice.balance_mxn > 190000) {
      this.setState({ messageText: 'El monto maximo por transaccion es de $190,000 MXN' })
    } else {
      this.setState({ messageText: '' })
    }


  }

  //Validacion para tomar en cuenta la forma de calcular pago   
  handlePay = (event) => {
    if (event.target.value === 'Si') {//Pago manual
      this.setState({ pagoManual: true, pagoAutomatico: false })
    } else {//Pago automatico
      this.setState({ pagoAutomatico: true, pagoManual: false })
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <label>Factura a Pagar</label>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>{t('dashboard.invoices.col_remission')}</th>
              <th>Saldo a pagar</th>
              <th>Tipo de cambio</th>
              <th>Saldo a pagar en MXN</th>
            </tr>
          </thead>
          <tbody>
            {this.props.get_data_invoices.map((invoice, index) =>
              <tr key={index}>
                <td>{invoice.remission}</td>
                <td>{"$" + Number(invoice.balance).toLocaleString("en-US") + " " + invoice.balance_cur}</td>
                <td>{invoice.balance_cur === "USD" ? Number(invoice.balance_rate).toLocaleString("en-US") + " MXN" : "N/A"}</td>
                <td>{"$" + Number(invoice.balance_mxn).toLocaleString("en-US") + " MXN"}</td>
              </tr>
            )}
            <tr>
              <td>Total del abono a facturar</td>
              <td></td>
              <td></td>
              <td>{"$" + Number(this.state.ingresoPago).toLocaleString("en-US") + " MXN"}</td>
            </tr>
          </tbody>
        </table>
        {this.props.get_data_invoices.length === 1 || this.props.totalPago >= 190000 ? (
          <div className="col-xs-12">
            <div className='col-md-4'>
              <div className='col-md-9' style={{ textAlign: 'end' }}>
                <p>&nbsp;</p>
                <label style={{ textDecoration: 'underline', fontSize: 'larger' }}>Modifcar monto de pago</label>
              </div>
              <div className='col-md-3' style={{ textAlign: 'end' }}>
                <p>&nbsp;</p>
                <label>
                  <input type="radio" name="type_pay" value="No" required onChange={this.handlePay} style={{ position: 'absolute' }} defaultChecked={true} />
                  <p style={{ paddingRight: '5px', fontSize: 'small', color: '#798395' }}>No</p>
                </label>
                <label>
                  <input type="radio" name="type_pay" value="Si" required onChange={this.handlePay} style={{ position: 'absolute' }} />
                  <p style={{ paddingLeft: '25px', paddingRight: '5px', fontSize: 'small', color: '#798395' }}>Si</p>
                </label>
              </div>
            </div>
            <div className='col-md-8' style={{ borderTop: '5px solid #f0672e66', paddingTop: '10px' }}>
              {this.props.totalPago <= 190000 ? (
                <div>
                  {(this.state.pagoAutomatico) ? this.pagoAutomatico(t) : ''}
                  {(this.state.pagoManual) ? this.pagoManual(t) : ''}
                </div>
              ) : (
                this.pagoManual(t)
              )}
            </div>
          </div>
        ) : this.pagoAutomatico(t)}
      </div>
    );
  }

  pagoAutomatico = (t) => {
    const TotalPago = this.state.totalPago ? Number(this.state.totalPago).toFixed(2) : 0
    const ComisionPago = this.state.comisionPago ? Number(this.state.comisionPago).toFixed(2) : 0
    const IngresoPago = this.state.ingresoPago ? Number(this.state.ingresoPago).toFixed(2) : 0
    return (
      <div>
        <div className='col-md-4 form-group'>
          <label htmlFor="deposits">{t('dashboard.invoice_payment.holder_amount')} </label>
          <input className="form-control" id="deposit_pay" readOnly placeholder="0.00" max="190000" type="number" value={TotalPago} />
        </div>
        <div className='col-md-4 form-group'>
          <label htmlFor="comission">{t('dashboard.invoice_payment.comission')}</label>
          <input className="form-control" id="balance_pay" type="text" readOnly placeholder="0.00" value={ComisionPago} />
        </div>
        <div className='col-md-4 form-group'>
          <label htmlFor="total">{t('dashboard.invoice_payment.label_deposits')}</label>
          <input className="form-control" id="total_pay" type="text" readOnly placeholder="0.00" value={IngresoPago} />
        </div>
        <i style={textColor}>{this.state.messageText}</i>
      </div>
    )
  }

  pagoManual = (t) => {
    return (
      <div>
        <div className='col-md-4 form-group'>
          <label htmlFor="deposits">{t('dashboard.invoice_payment.holder_amount')} </label>
          <input className="form-control" id="deposit_pay" placeholder="0.00" type="number" max="190000" required onChange={this.props.handleInputChange} />
        </div>
        <div className='col-md-4 form-group'>
          <label htmlFor="comission">{t('dashboard.invoice_payment.comission')}</label>
          <input className="form-control" id="balance_pay" type={this.props.typeInput} readOnly required placeholder="0.00" value={this.props.comisionPago} />
        </div>
        <div className='col-md-4 form-group'>
          <label htmlFor="total">{t('dashboard.invoice_payment.label_deposits')}</label>
          <input className="form-control" id="total_pay" type={this.props.typeInput} readOnly required placeholder="0.00" value={this.props.totalPago} />
        </div>
        <i style={textColor}>{this.props.messageText}</i>
      </div>
    )
  }

}

export default translate('common')(Summary);

const textColor = { fontSize: '10pt', fontWeight: '100', color: '#f0672e', textDecoration: 'underline' }


// WEBPACK FOOTER //
// ./src/dashboard/invoices/payment/Summary.js